import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatChipOption, MatChipListbox, MatChipSelectionChange } from '@angular/material/chips';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CognitoUser } from 'app/core/auth-shim';
import { filter, find } from 'lodash-es'
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { DataShareService } from '../../../services/data-share.service';
import { AccountMembership, AccountType, APIService, UpdateAccountMembershipAction, UpdateAccountMembershipInput, UpdateUserInput, User, UserStatus } from '../../API.service.custom';
import { AuthService } from '../auth.service';
import localforage from 'localforage';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-trial-over',
    templateUrl: './trial-over.component.html',
    styleUrls: ['./trial-over.component.scss'],
    imports: [RouterLink, RouterLinkActive, MatChipListbox, MatChipOption, TitleCasePipe]
})
export class TrialOverComponent implements OnInit, OnDestroy {
  daysRemainingInTrial : number = null
  private userId = null;
  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();
  isLoading = true

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  private userDetails_: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public userDetails = this.userDetails_.asObservable();
  private activeAccountMemberships: AccountMembership[] = [];
  private registeredUser: User = null;

  membershipId = null;
  activeAccount : AccountMembership = null;
  availableMemberships : AccountMembership[] = [];

  accountMembershipUpdateInitiated : Boolean = false;
  accountsInNeedOfAcceptance : AccountMembership[] = [];
  private componentDestroyed = false;


  constructor(
        private dataService: DataShareService,
        private api: APIService,
        private toastr: ToastrService,
        private titleService: Title,
        private logger: NGXLogger,
        private auth: AuthService,
        private route: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Trial');
    this.route.paramMap.subscribe(params => {
      this.deferStateUpdate(() => {
        this.membershipId = params.get('id');
        this.getUserDetailsAndId();
      });
    })

  }

  ngOnDestroy(): void {
    this.componentDestroyed = true;
  }

  public async getUserDetailsAndId() {
    this.busy_.next(true);
    this.errorMessage_.next('');
    try {
      const userDetails: CognitoUser = await this.auth.currentAuthenticatedUser();
      this.userId = userDetails.getSignInUserSession().getIdToken().payload.userId;
      if (this.userId) {
        this.getUserRegistrationDetail(this.userId);
      }
      this.userDetails_.next(userDetails);
    } catch (err) {
      this.errorMessage_.next(err.message || err);
    } finally {
      this.busy_.next(false);
    }
  }

  private getUserRegistrationDetail(userId: string) {
    this.api.GetUser(userId).then(async event => {
      this.logger.log('User Registration Detail Fetched : ', event);
      if (event) {
        this.deferStateUpdate(() => {
          this.registeredUser = event;
          this.dataService.setRegisteredUser(this.registeredUser)
        });
        this.getuserAccountMemberships(event);
      }
    })
      .catch(e => {
        this.logger.log('error fetching user registration detail', e);
      });

  }

  private getuserAccountMemberships(user: User) {
    this.api.AccountsByUser(user.id).then(event => {
      this.deferStateUpdate(() => {
        this.logger.log('User Account Memberships Fetched : ', event);
        if (event && event.items && event.items.length > 0) {
          event.items.forEach(item => {
            item.user = user;
          });
          this.activeAccountMemberships = filter(event.items, function(o) { 
            return (o.userAccountStatus == UserStatus.ACTIVE || o.userAccountStatus == UserStatus.APPROVED) && (o.account.accountType == AccountType.TEAM || o.account.accountType == AccountType.TEAM_TRIAL);
          });
          this.accountsInNeedOfAcceptance = filter(event.items, function (item) {
            return item.userAccountStatus == UserStatus.APPROVED;
          });
          console.log("activeAccountMemberships memberships are ", this.activeAccountMemberships);
          if(this.activeAccountMemberships.length > 0){
            if(this.membershipId != null && this.membershipId != ""){
              this.activeAccount = find(this.activeAccountMemberships, { 'id': this.membershipId});
              if(this.activeAccount && this.activeAccount.account && this.activeAccount.account.accountType == AccountType.TEAM_TRIAL && (this.activeAccount.account.trialAccountEndDate < (new Date()).toISOString())){
                var membershipAccountId = this.activeAccount.accountId;
                this.availableMemberships = filter(this.activeAccountMemberships, function(o) { 
                  return o.account.id != membershipAccountId && (!o.account.trialAccountEndDate || o.account.trialAccountEndDate > (new Date()).toISOString()); 
              });
              console.log("Available memberships are ", this.availableMemberships);
              }
              else{
                this.updateLastActiveAccountWeb();
              }
            }
            else
              this.activeAccount = this.activeAccountMemberships[0];
          }
        }
        this.isLoading = false;
        this.getTrialDaysRemaining();
      });
    })
      .catch(e => {
        this.logger.log('error fetching user account memberships', e);
        this.deferStateUpdate(() => {
          this.isLoading = false;
        });
      });
  }


  getTrialDaysRemaining(){
    if(this.activeAccount.account.accountType == AccountType.TEAM_TRIAL && this.activeAccount.account.trialAccountEndDate != null){
      var currentDate = new Date()
      var trialExpiryDate = new Date(this.activeAccount.account.trialAccountEndDate)
      var difference = trialExpiryDate.getTime() - currentDate.getTime();
      const remainingDays = Math.ceil(difference / (1000 * 3600 * 24));
      this.deferStateUpdate(() => {
        this.daysRemainingInTrial = remainingDays;
        if(this.daysRemainingInTrial > 0)
          this.router.navigate(['/home/dashboard']);
      });
    }
  }

  onChipSelectionChange(event: MatChipSelectionChange, membership: AccountMembership) {
    if (!event.isUserInput) {
      return;
    }

    if (event.selected) {
      this.deferStateUpdate(() => {
        this.activeAccount = membership;
        this.updateLastActiveAccountWeb();
      });
    }
  }

  rejectMembership(ev, membership : AccountMembership){
    ev.stopPropagation();
    if(!this.accountMembershipUpdateInitiated){
      this.accountMembershipUpdateInitiated = true;
      var input = <UpdateAccountMembershipInput>{}
      input.id = membership.id
      input.updateAction = UpdateAccountMembershipAction.REJECT_MEMBERSHIP
      if(membership.accountEmail == null)
        input.accountEmail = this.registeredUser.registeredEmail
      this.api.UpdateAccountMembership(input).then(event => {
        this.deferStateUpdate(() => {
          this.accountMembershipUpdateInitiated = false;
          this.logger.log('Account Membership Rejected : ', event);
          this.accountsInNeedOfAcceptance.splice(0,1)
          this.router.navigate(['/home/dashboard']);
        });
      })
        .catch(e => {
          this.deferStateUpdate(() => {
            this.accountMembershipUpdateInitiated = false;
            this.logger.log('Error in accepting account membership', e);
          });
          this.showErrorInToastr(e, 'Error in accepting account membership')
        });
    }
  }

  acceptMembership(ev, membership : AccountMembership){
    ev.stopPropagation();
    if(!this.accountMembershipUpdateInitiated){
      this.accountMembershipUpdateInitiated = true;
      var input = <UpdateAccountMembershipInput>{}
      input.id = membership.id
      input.updateAction = UpdateAccountMembershipAction.ACCEPT_MEMBERSHIP
      if(membership.accountEmail == null)
        input.accountEmail = this.registeredUser.registeredEmail
      this.api.UpdateAccountMembership(input).then(event => {
        this.deferStateUpdate(() => {
          this.accountMembershipUpdateInitiated = false;
          this.logger.log('Account Membership Accepted : ', event);
          this.accountsInNeedOfAcceptance.splice(0,1)
          this.updateLastActiveAccountWeb();
        });
      })
        .catch(e => {
          this.deferStateUpdate(() => {
            this.accountMembershipUpdateInitiated = false;
            this.logger.log('Error in accepting account membership', e);
          });
          this.showErrorInToastr(e, 'Error in accepting account membership')
        });
    }
  }

  updateLastActiveAccountWeb() {
    localforage.setItem('lastActiveAccountSelectedInBrowser', this.activeAccount.accountId);
    let input = <UpdateUserInput>{};
    input.lastSelectedAccountWeb = this.activeAccount.accountId;
    input.id = this.userId;
    this.api.UpdateUser(input).then(event => {
      this.logger.log('Last Active Account Web Updated : ', event);
      // Full page reload to cleanly initialize app from trial-over transition
      window.location.href = '/';
    })
      .catch(e => {
        this.logger.log('error updating last active account for user', e);
      });
  }

  extendFreeTrial(){
    this.toastr.error('Trial Period Can Not be Extended at this time. Please reach out to us.');
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        this.logger.log(e.errors[_i].message);
      }
    }
  }

  private deferStateUpdate(work: () => void | Promise<void>) {
    setTimeout(async () => {
      await work();
      if (!this.componentDestroyed) {
        this.cdr.detectChanges();
      }
    }, 0);
  }

}

